import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import useStatus from '@shared-submodule/sm-hooks/useStatus'

const Result = dynamic(() => import('./result'))
const Upcoming = dynamic(() => import('./upcoming'))
const Header = dynamic(() => import('./header'))

const MatchHeader = ({ data, is100 }) => {
  const { sStatusStr } = useStatus(data)
  const [disableData, setDisableData] = useState(!!(sStatusStr === 'live' || sStatusStr === 'completed' || sStatusStr === 'cancelled'))

  useEffect(() => {
    setDisableData(!!(sStatusStr === 'live' || sStatusStr === 'completed' || sStatusStr === 'cancelled'))
  }, [data])

  return (
    <>
      {((sStatusStr === 'live' || sStatusStr === 'completed' || sStatusStr === 'cancelled') && disableData) && <Result data={data} is100={is100}/>}
      {(sStatusStr === 'scheduled' || !disableData) && (
        <>
          <Header data={data} />
          <div className='d-block d-md-none'>
            <Upcoming data={data} />
          </div>
        </>
      )}
    </>
  )
}

export default MatchHeader

MatchHeader.propTypes = {
  data: PropTypes.object,
  is100: PropTypes.bool
}
